var map = {
	"./ava_Instagram.svg": 7851,
	"./galeria_Instagram.svg": 9550,
	"./jamh_Instagram.svg": 3273,
	"./kbmo_Instagram.svg": 9014,
	"./ktkh_Instagram.svg": 9333,
	"./pmh_Instagram.svg": 498,
	"./szimh_Instagram.svg": 5266
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6125;